<template>
  <tr
    v-if="showItem"

    :class="classNames"
    class="list-item"

    @click="setSelected"
  >
    <template v-for="(value, key, index) in item">
      <template v-if="!blackListedItems.includes(key.toLowerCase())">
        <template v-if="key === 'Gemeente'">
          <td :key="`${key}-${value}`" :class="regionClassName">
            {{value}}
          </td>
        </template>
        <template v-else-if="!isNaN(value)">
          <td
            :key="`${key}-${value}`"

            :class="{
              'is-colored': index === 0,
              'is-centered': key === 'Rapportcijfer'
            }"
          >
            <template v-if="index === 0">
              <span
                class="color-box"
                :style="setStyle(index)"
              >
                {{ value | thousandsSeparator }}
              </span>
            </template>
            <template v-else>
              {{ value | thousandsSeparator }}
            </template>
          </td>
        </template>
        <template v-else-if="key === 'Positie'">
          <template v-if="selectedYear !== '2018'">
            <td :key="`${key}-${value}`" class="is-position is-centered">
              <template v-if="value === 'nvt'">
                <div :class="getClassName(value)">-</div>
              </template>
              <template v-else>
                <div :class="getClassName(value)">{{ value }}</div>
              </template>
            </td>
          </template>
        </template>
        <template v-else>
          <td :key="`${key}-${value}`">
            {{value | decimalSeparator}}
          </td>
        </template>
      </template>
    </template>
  </tr>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ListItem',

  props: {
    /**
     * A list item with entry data
     */
    item: {
      type: Object,
      required: true,
    },
    /**
     * Item that shouldn't be shown in the list
     */
    blackListedItems: {
      type: Array,
      required: false,
      default: () => [],
    },
    /**
     * Is a list item clickable
     */
    clickable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      showItem: true,
    };
  },

  computed: {
    ...mapState({
      selectedMarker: (state) => state.markers.selected,
      selectedItem: (state) => state.list.selected,
      selectedRegion: (state) => state.dataLayer.selected,
      selectedYear: (state) => state.rawData.year,
    }),

    classNames() {
      if (this.item.Gemeente === this.selectedItem?.Gemeente) {
        return 'is-active';
      }

      return '';
    },

    regionClassName() {
      if (!Object.keys(this.item).includes('Ranking 2018') && !Object.keys(this.item).includes('Ranking 2019')) {
        return '';
      }

      if (this.item.Positie === 'nvt' || !this.item.Positie) {
        return 'is-new';
      }

      return '';
    },
  },

  watch: {
    selectedMarker(selectedMarker) {
      if (selectedMarker === null) {
        this.$store.commit('list/deselect');

        return;
      }

      const { marker } = selectedMarker;

      if (this.item.id === marker.id) {
        this.setSelected();
      }
    },

    selectedRegion(selectedRegion) {
      if (selectedRegion === null) {
        this.$store.commit('list/deselect');

        return;
      }

      if (
        this.item.Gemeente === selectedRegion
        && selectedRegion !== this.selectedItem?.Gemeente
      ) {
        this.setSelected();
      }
    },
  },

  methods: {
    getClassName(value) {
      if (value === '=') {
        return 'position-same';
      }

      if (value === 's') {
        return 'position-high';
      }

      if (value === 'd') {
        return 'position-down';
      }

      return '';
    },

    setSelected() {
      if (!this.clickable) {
        return;
      }

      if (this.item.Gemeente !== this.selectedItem?.Gemeente) {
        this.$store.commit('list/select', this.item);
        this.$store.commit('counter/stop');
      } else {
        this.$store.commit('list/deselect');
        this.$store.commit('counter/start');
      }
    },

    toggleItem(value) {
      this.showItem = value;
    },

    setStyle(index) {
      if (index === 0) {
        return `background-color: ${this.item.colors}`;
      }

      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
  // stylelint-disable jeroensmits/declaration-use-variable
  td {
    @include font-size(milli);

    padding-bottom: 0;
    padding-top: 0;
    vertical-align: center;
    white-space: nowrap;

    &.is-centered {
      text-align: center;
    }

    &.is-colored {
      background-color: $color-white;
      text-align: center;

      .color-box {
        display: inline-block;
        text-align: center;
        width: 25px;
      }
    }

    &.is-position {
      line-height: 0;
    }

    &.is-new::after {
      content: '*';
    }
  }

  .position-same {
    @include font-size(zero);

    display: inline-block;
    height: 6px;
    overflow: hidden;
    text-indent: -999px;
    width: 8px;

    &::before, &::after {
      background-color: $color-alto;
      content: '';
      display: block;
      height: 2px;
      margin-bottom: 2px;
    }

    &::after {
      margin-bottom: 0;
    }
  }

  .position-high {
    @include font-size(zero);

    border-bottom: solid 8px $color-conifer;
    border-left: solid 4px transparent;
    border-right: solid 4px transparent;
    display: inline-block;
    height: 0;
    overflow: hidden;
    text-indent: -999px;
    width: 0;
  }

  .position-down {
    @include font-size(zero);

    border-left: solid 4px transparent;
    border-right: solid 4px transparent;
    border-top: solid 8px $color-alizarin-crimson;
    display: inline-block;
    height: 0;
    overflow: hidden;
    text-indent: -999px;
    width: 0;
  }
</style>
